// extracted by mini-css-extract-plugin
export var text = "_15-0";